Vue.component("InvisibleHotspot", {
    template: `
        <div class="InvisibleHotspot hotspot"\>
        </div>
    `
})